import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import init from '../../firebase';
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { mehandiTtkSchema } from '../schemas';
import axios from "axios";
import { NumericFormat } from 'react-number-format';
import ThinksToKnowStatus from './ThinksToKnowStatus';
const MehandiTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            // const details = rawDetails ? JSON.parse(rawDetails) : null;
            if (details) {
                setMerchant(details);
                // formik.setValues(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const mehandiDesignOption = checkboxData.mehandiDesignType;
    const travelCostOption = checkboxData.travelCost;
    const travelPreferenceOption = checkboxData.travelPreference;

    const formik = useFormik({
        initialValues: {
            mehandiPrice: Math.floor(merchant?.mehandiPrice * currency.value) || '',
            noOfEmployee: merchant?.noOfEmployee || '',
            mehandiPerHandPrice: Math.floor(merchant?.mehandiPerHandPrice * currency.value) || '',
            maxGuest: merchant?.maxGuest || '',
            TranditionalMehandi: merchant?.TranditionalMehandi || '',
            workingSince: merchant?.workingSince || [],
            mehandiDesign: merchant?.mehandiDesign || [],
            travelCost: merchant?.travelCost || [],
            areaOfWork: merchant?.areaOfWork || [],
            TravelPreference: merchant?.TravelPreference || [],
        },
        enableReinitialize: true,
        validationSchema: mehandiTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: {
                        ...values,
                        mehandiPrice: Math.floor(values.mehandiPrice * currency.country_value),
                        mehandiPerHandPrice: Math.floor(values.mehandiPerHandPrice * currency.country_value)
                    }
                };
                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                 <ThinksToKnowStatus/>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header  text-white text-center ' style={{ backgroundColor: '#085f9a' }}>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Bridal Mehandi Price</th>
                                                            <th style={{ width: '25%' }}>Maximum Guest</th>
                                                            <th style={{ width: '25%' }}>Mehandi Design Type</th>

                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <p key={index}>{item.value}</p>
                                                                })
                                                            }</td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.mehandiPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>{merchant.maxGuest}</td>
                                                            <td>{
                                                                merchant.mehandiDesign
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Travel Cost</th>
                                                            <th>Number Of Employees</th>
                                                            <th>Coust/Family Per Hand Price</th>
                                                            <th>Travel Preference</th>
                                                        </tr>
                                                        <tr>

                                                            <td>{
                                                                merchant.travelCost
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>
                                                            <td> {merchant.noOfEmployee}</td>
                                                            <td>
                                                                <NumericFormat
                                                                    value={Math.floor(
                                                                        currency.value * merchant.mehandiPerHandPrice
                                                                    )}
                                                                    displayType="text"
                                                                    thousandsGroupStyle={
                                                                        currency.symbol === "₹" ? "lakh" : "thousand"
                                                                    }
                                                                    thousandSeparator=","
                                                                    renderText={(formattedValue) => (
                                                                        <span>
                                                                            {currency.symbol}&nbsp;{formattedValue}
                                                                        </span>
                                                                    )}
                                                                />
                                                            </td>
                                                            <td>{
                                                                merchant.TravelPreference
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>

                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Traditional Mehandi Price</th>
                                                            <th>Area of working </th>
                                                        </tr>
                                                        <tr>
                                                            <td>{merchant.TranditionalMehandi}</td>
                                                            <td>{
                                                                merchant.areaOfWork
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn text-white mb-2' style={{ backgroundColor: '#085f9a' }} onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Bridal Mehandi Price</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Bridal Mehandi Price'
                                                            className='form-control'
                                                            name="mehandiPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.mehandiPrice} />
                                                    </div>
                                                    {formik.touched.mehandiPrice && formik.errors.mehandiPrice ? (
                                                        <div className="text-danger">{formik.errors.mehandiPrice}</div>
                                                    ) : null}
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Maximum Guest</label>
                                                        <input
                                                            type='number'
                                                            placeholder='Maximum Guest'
                                                            className='form-control'
                                                            name="maxGuest"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.maxGuest}
                                                        />
                                                        {formik.touched.maxGuest && formik.errors.maxGuest ? (
                                                            <div className="text-danger">{formik.errors.maxGuest}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Mehandi Design Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={mehandiDesignOption}
                                                            selected
                                                            value={formik.values.mehandiDesign}
                                                            onChange={(mehandiDesign) => formik.setFieldValue('mehandiDesign', mehandiDesign)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.mehandiDesign && formik.errors.mehandiDesign ? (
                                                            <div className="text-danger">{formik.errors.mehandiDesign}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travel Cost</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={travelCostOption}
                                                            selected
                                                            value={formik.values.travelCost}
                                                            onChange={(travelCost) => formik.setFieldValue('travelCost', travelCost)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.travelCost && formik.errors.travelCost ? (
                                                            <div className="text-danger">{formik.errors.travelCost}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Number Of Employees</label>
                                                        <input
                                                            type='number'
                                                            placeholder='Number Of Employees'
                                                            className='form-control'
                                                            name="noOfEmployee"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.noOfEmployee}
                                                        />
                                                        {formik.touched.noOfEmployee && formik.errors.noOfEmployee ? (
                                                            <div className="text-danger">{formik.errors.noOfEmployee}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="" for="inlineFormInputGroup">Guest/Family Per Hand Price</label>
                                                    <div class="input-group mb-2">
                                                        <div class="input-group-prepend">
                                                            <div class="input-group-text">{currency?.symbol}</div>
                                                        </div>
                                                        <input
                                                            type='number'
                                                            placeholder='Guest/Family Per Hand Price'
                                                            className='form-control'
                                                            name="mehandiPerHandPrice"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.mehandiPerHandPrice} />
                                                    </div>
                                                    {formik.touched.mehandiPerHandPrice && formik.errors.mehandiPerHandPrice ? (
                                                        <div className="text-danger">{formik.errors.mehandiPerHandPrice}</div>
                                                    ) : null}
                                                </div>

                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Travel Preference</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={travelPreferenceOption}
                                                            selected
                                                            value={formik.values.TravelPreference}
                                                            onChange={(TravelPreference) => formik.setFieldValue('TravelPreference', TravelPreference)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.TravelPreference && formik.errors.TravelPreference ? (
                                                            <div className="text-danger">{formik.errors.TravelPreference}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Traditional Mehandi Price</label>
                                                        <input
                                                            type='number'
                                                            placeholder='Traditional Mehandi Price'
                                                            className='form-control'
                                                            name="TranditionalMehandi"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.TranditionalMehandi}
                                                        />
                                                        {formik.touched.TranditionalMehandi && formik.errors.TranditionalMehandi ? (
                                                            <div className="text-danger">{formik.errors.TranditionalMehandi}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Area of working </label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWork}
                                                            onChange={(areaOfWork) => formik.setFieldValue('areaOfWork', areaOfWork)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWork && formik.errors.areaOfWork ? (
                                                            <div className="text-danger">{formik.errors.areaOfWork}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn text-white' type='submit' style={{ backgroundColor: '#085f9a' }}>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MehandiTTK